import { useEffect, useRef, useState } from 'preact/hooks';
import { useAsyncAction } from '../../hooks/use-async-action';
import { getSchema } from '../../api/schema';
import { Card } from '../../components/card';
import { Spinner } from '../../components/spinner';
import { EmptyState } from '../../components/empty-state';
import { ErdCanvas } from './erd-canvas';

export function SchemaTab() {
  const mounted = useRef(false);
  const schema = useAsyncAction(getSchema);
  const [spinning, setSpinning] = useState(false);

  useEffect(() => {
    if (mounted.current) return;
    mounted.current = true;
    schema.execute();
  }, []);

  const handleRefresh = async () => {
    setSpinning(true);
    await schema.execute();
    setTimeout(() => setSpinning(false), 600);
  };

  const tables = schema.result?.tables ?? [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Card>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
          <h2 style={{ marginBottom: 0 }}>Entity Relationship Diagram</h2>
          <button class="btn-icon" onClick={handleRefresh} title="Refresh">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              style={spinning ? 'animation:spin 0.6s linear' : undefined}
            >
              <path d="M21 2v6h-6" />
              <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
              <path d="M3 22v-6h6" />
              <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
            </svg>
          </button>
        </div>

        {/* Legend */}
        <div style={{ display: 'flex', gap: '20px', marginBottom: '16px', fontSize: '0.78rem', color: 'var(--text-secondary)' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--accent)', display: 'inline-block' }} />
            Primary Key
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--blue)', display: 'inline-block' }} />
            Foreign Key
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <svg width="24" height="2" style={{ display: 'inline-block' }}>
              <line x1="0" y1="1" x2="24" y2="1" stroke="var(--text-tertiary)" stroke-width="1.5" stroke-dasharray="4 2" />
            </svg>
            Relationship
          </span>
        </div>

        {schema.loading && tables.length === 0 ? (
          <Spinner text="Loading schema" />
        ) : schema.error ? (
          <EmptyState message="Failed to load schema" />
        ) : tables.length === 0 ? (
          <EmptyState message="No tables found" />
        ) : (
          <ErdCanvas tables={tables} />
        )}
      </Card>
    </div>
  );
}
